module.exports = __webpack_public_path__ + "img/fuel-truck.9c7a8472.png";